module.exports = __webpack_public_path__ + "static/img/12.b48a195.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/12.png
// module id = wyUR
// module chunks = 0